import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "bsp_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      // localStorage blocked; show banner once per page load
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (err) {
      console.warn("Could not persist cookie consent:", err);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[100] bg-[#1A1F3D] text-white border-t border-[#D4A853]/30 shadow-[0_-4px_24px_rgba(0,0,0,0.18)]"
      data-testid="cookie-banner"
    >
      <div className="container-bsp py-4 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5">
        <p className="text-sm leading-relaxed flex-1">
          We use essential cookies to keep you logged in and process payments. By continuing to use this site, you agree to our use of cookies.
        </p>
        <div className="flex items-center gap-4 shrink-0">
          <Link
            to="/cookie-policy"
            className="text-sm text-white/80 hover:text-[#D4A853] underline-offset-4 hover:underline transition-colors"
            data-testid="cookie-policy-link"
          >
            Cookie Policy
          </Link>
          <button
            type="button"
            onClick={accept}
            className="px-4 py-2 rounded-lg bg-[#D4A853] text-[#1A1F3D] text-sm font-semibold hover:bg-[#C29543] transition-colors"
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
